import { useState } from "react";
import { TransactionType, TransactionTypes } from "../../shared/Consts";import { Select, MenuItem } from "@mui/material";
import { IAddHoldingProps } from "./IAddHolding";
import Dropdown from "../../libs/dropdown/Dropdown";

export interface IActionSelectProps {
    current:number;
    onChange:(action:number) => void;
}

export function useAction(props:IAddHoldingProps){
    const {transaction} = props;
    let selected:TransactionType;
    if (transaction) selected = transaction.type;
    else if (typeof(props.type)!="undefined") selected = props.type;
    else selected = TransactionTypes[0].id

    const [type,setType] = useState<number>(selected)
    return {type,setType}
}

export default function ActionSelect(props:IActionSelectProps){
    const options = TransactionTypes.map(action => ({value:action.id,label:action.name}))
    const onChange = (action:number|null) => props.onChange(action!)
    return <Dropdown value={props.current} options={options} onChange={onChange}/>
}